<template>
   <div :class="classObject" v-on:click="showCategory(filter)">{{ filter }}</div>
</template>
<script>
export default {
  props: ['filter'],
  data() {
    return {
      classObject: {
        'creator-filter__button': true,
        'is_active': false
      }
    }
  },
  methods: {
    showCategory: function(cat) {
      if (this.$store.state.categoryDisplay === cat) {
        this.$store.commit('setCategoryToDisplay', '');
        this.$store.commit('setShowAllCreators', true);
      } else {
        // this.classObject.is_active = true;
        this.$store.commit('setCategoryToDisplay', cat);
        this.$store.commit('setShowAllCreators', false);
      }
    }
  },
  watch: {
    '$store.state.categoryDisplay': function() {
      if(this.$store.state.categoryDisplay === this.filter) {
        this.classObject.is_active = true;
      } else {
        this.classObject.is_active = false;
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// FilterButton.vue?bfa22e9c